import { render, staticRenderFns } from "./fa_tenant_view.vue?vue&type=template&id=381933d4&scoped=true&"
import script from "./fa_tenant_view.vue?vue&type=script&lang=js&"
export * from "./fa_tenant_view.vue?vue&type=script&lang=js&"
import style0 from "./fa_tenant_view.vue?vue&type=style&index=0&id=381933d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381933d4",
  null
  
)

export default component.exports